import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import UserAdjustmentsValidatorClassicBuilder from './user-adjustments-validator-classic-builder';
import UserAdjustmentsValidatorShowdownBuilder from './user-adjustments-validator-showdown-builder';
import EditedLineupValidatorClassicBuilder from './edited-lineup-validator-classic-builder';
import EditedLineupValidatorShowdownBuilder from './edited-lineup-validator-showdown-builder';

const userAdjustmentsValidatorClassesMap = {
    [Const.GAME_TYPE_CLASSIC]: UserAdjustmentsValidatorClassicBuilder,
    [Const.GAME_TYPE_SHOWDOWN]: UserAdjustmentsValidatorShowdownBuilder,
};

export class UserAdjustmentsValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in userAdjustmentsValidatorClassesMap) {
            return new userAdjustmentsValidatorClassesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

const editedLineupValidatorClassesMap = {
    [Const.GAME_TYPE_CLASSIC]: EditedLineupValidatorClassicBuilder,
    [Const.GAME_TYPE_SHOWDOWN]: EditedLineupValidatorShowdownBuilder,
};

export class EditedLineupValidatorFactory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in editedLineupValidatorClassesMap) {
            return new editedLineupValidatorClassesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}
